import React from "react";
import {styled} from "@mui/material/styles";

import {Title} from "@/components/typography/index.jsx";
import {COLOR_GREY} from "@/themes/colors.jsx";
import {useFormProgress} from "@/hooks/useFormProgress.jsx";

export default function FormProgress({children, ...props}) {
    const {progressDisplay, stepsCount, currentProgress} = useFormProgress() || {
        progressDisplay: null,
        stepsCount: 0,
        currentProgress: 0
    };

    return (
        <Container
            {...props}
        >
            <Row>
                <Title>{children}</Title>
                {progressDisplay && (
                    <Progress>Step {currentProgress}/{stepsCount}</Progress>
                )}
            </Row>
        </Container>
    );
}

const Container = styled('div')({
    marginBottom: '0.5rem',
    position: 'relative',
});

const Row = styled('div')({
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});

const Progress = styled('div')({
    fontSize: '15px',
    fontWeight: 800,
    lineHeight: '17.9px',
    color: COLOR_GREY,
    whiteSpace: "nowrap",
});
